import { call, takeEvery, takeLatest, put, delay } from "redux-saga/effects";
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import {
  apiError,
  loginSuccess,
  fetchProvidersSuccess,
  fetchProvidersFailure,
  fetchPermissionsSuccess,
  fetchPermissionsFailure,
  fetchFacilitiesSuccess,
  fetchFacilitiesFailure
} from "./actions";


import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import axios from "axios";
import md5 from "md5";
import Swal from "sweetalert2";

const fireBaseBackend = getFirebaseBackend();

function* fetchProvidersAndPermissions(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const providersResponse = yield call(
      axios.get,
      `${process.env.REACT_APP_API_URL}/Providers/getProviders`,
      { headers }
    );
    console.log("Providers response:", providersResponse);
    const providers = providersResponse || []; 
    console.log("Providers fetched:", providers);
    yield delay(500);
    
    yield put(fetchProvidersSuccess(providers));

    //Facilities
    const facilitiesResponse = yield call(
      axios.get,
      `${process.env.REACT_APP_API_URL}/Facilities/getFacilities`,
      { headers }
    );
    console.log("Facilities response:", facilitiesResponse);
    const facilities = facilitiesResponse || []; 
    console.log("Facilities fetched:", facilities);
    yield delay(500);
    
    yield put(fetchFacilitiesSuccess(facilities));
  } catch (error) {
    console.error("Failed to fetch providers:", error);
    yield put(fetchProvidersFailure(error.message || "Failed to fetch providers"));
    yield put(fetchFacilitiesFailure(error.message || "Failed to fetch facilities"));
  }
}

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const postData = {
        UserName: user.UserName,
        password: md5(user.password),
        app: true,
      };
      const loginResponse = yield call(
        axios.post,
        `${process.env.REACT_APP_API_URL}/User/login`,
        postData
      );

      if (loginResponse && loginResponse.user && loginResponse.user.token) {
        console.log("Login Success +++: ");
        localStorage.setItem("authUser", JSON.stringify(loginResponse.user));
        localStorage.setItem("Thyra_Token", loginResponse.user.token);
        localStorage.setItem("User_Type", loginResponse.user.userType);
        localStorage.setItem("default_practice", loginResponse.user.defaultpracticeId);
        localStorage.setItem("UserName", loginResponse.user.userName);
        localStorage.setItem("Emailaddress", loginResponse.user.email);

        // Store permissions from login response in Redux
        const permissions = loginResponse.right || {};
        console.log("Permissions from login:", permissions);
        localStorage.setItem("permissionStored", JSON.stringify(permissions));
        yield put(fetchPermissionsSuccess(permissions));

        // Fetch providers separately
        const headers = {
          Authorization: `Bearer ${loginResponse.user.token}`,
          "Content-Type": "application/json",
        };
        const providersResponse = yield call(
          axios.get,
          `${process.env.REACT_APP_API_URL}/Providers/getProviders`,
          { headers }
        );
        const providers = providersResponse || [];
        console.log("Providers fetched:", providers);
        yield put(fetchProvidersSuccess(providers));

        yield put(loginSuccess(loginResponse.user));
        yield delay(500); // Ensure Redux updates


        //Facilities
        const facilitiesResponse = yield call(
          axios.get,
          `${process.env.REACT_APP_API_URL}/Facilities/getFacilities`,
          { headers }
        );
        const facilities = facilitiesResponse || [];
        console.log("Facilities fetched:", facilities);
        yield put(fetchFacilitiesSuccess(facilities));
        yield delay(500); // Ensure Redux updates

        history("/Patient");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 200);
      } else {
        yield call([Swal, Swal.fire], {
          title: "User Name or Password incorrect. Please enter valid credentials.",
          icon: "error",
          confirmButtonColor: "#0BB197",
          confirmButtonText: "Okay",
        });
        setTimeout(() => {
          window.location.reload();
        }, 200);
        throw new Error("Invalid credentials");
      }
    }
  } catch (error) {
    yield put(apiError(error.message || "Login failed"));
  }
}

function* logoutUser() {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("Thyra_Token");
    localStorage.removeItem("User_Type");
    localStorage.removeItem("default_practice");
    localStorage.removeItem("UserName");
    localStorage.removeItem("Emailaddress");
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      yield call(fireBaseBackend.logout);
    }
    yield put(fetchProvidersSuccess([]));
    yield put(fetchPermissionsSuccess({}));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, data, type);
      localStorage.setItem("authUser", JSON.stringify(response));
    } else {
      const response = yield call(postSocialLogin, data);
      localStorage.setItem("authUser", JSON.stringify(response));
    }
    history("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* initializeApp() {
  const token = localStorage.getItem("Thyra_Token");
  if (token) {
    yield call(fetchProvidersAndPermissions, token);
  }
}

export default function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeLatest("INITIALIZE_APP", initializeApp);
}